import { Badge, Button, IconButton, Tooltip, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import { getIcon } from "../../utils/iconConfig";
import CustomTooltip from "./CustomTooltip";

const StockCard = ({ data, variant = "default", }) => {
  const [details, setDetails] = useState([]);

  const getLocationIcon = (location) => {
    const locationMap = {
      "BBM Stock": "bbm",
      "BBS Stock": "bbs",
      "BBM Customer Stock": "bbmC",
      "BBS Customer Stock": "bbsC",
      "Headquarters Stock": "hq",
      "Idel Inventory": "IDL",
    };
    return locationMap[location] || "defaultIcon";
  };

  const ModifyDiaQlty = (data?.diaQlty ?? "-").replace(/(.+)(..)$/, "$1-$2");
  const goldColor = data?.goldColor?.[0]?.toUpperCase() ?? "";
  const showDetails = React.useMemo(
    () => [
      {
        left: [
          { label: data?.jewelCode, Icon: getIcon("Ring", "white"), access: true },
          { label: data?.styleNumber, Icon: getIcon("StyleIcon", data?.designClass?.toLowerCase()), access: true },
          {
            label: `${ModifyDiaQlty ?? 0} / ${data?.diaWt} Ct / ${data?.diaPcs} Pcs`,
            Icon: getIcon("Diamond", "stock_diamond"),
            tooltipTitle: "Diamond Quality / Diamond Weight / Diamond Pieces",
            access: true,
          },
          {
            label: `${data?.goldQlty}${goldColor} / ${data?.netWt} g / ${data?.grossWt} g `,
            Icon: getIcon("GoldBar", "gold_stock"),
            tooltipTitle: "Gold Purity / Gold Net Weight / Gold Gross Weight",
            access: true,
          },
          { label: `${data?.csWt} Ct / ${data?.csPcs} Pcs`, Icon: getIcon("GemStoneIcon", variant), tooltipTitle: "ColorStone Weight / ColorStone Pieces", access: true },
          { label: `${data?.otherWt} g / ${data?.otherPcs} Pcs`, Icon: getIcon("OtherMaterialIcon", variant), tooltipTitle: "OtherMaterial Weight / OtherMaterial Pieces", access: true },
          {
            label: `${data?.itemSize ?? 0} ${data?.memoClientName && "/"} ${data?.memoClientName && data?.memoClientName?.slice(0, 25).trim()}${data?.memoClientName && data?.memoClientName?.trim()?.length > 25 ? "..." : ""}`,
            Icon: getIcon("Scale"),
            tooltipTitle: `${data?.memoClientName && data?.memoClientName?.length < 25 ? `Size / ${data?.memoClientName}` : "Size"}`,
            access: true,
          },
        ],
      },
      {
        middle: [
          {
            label: `${data?.memoClientName ? "Memo" : "Location"}`,
            Icon: data?.memoClientName ? getIcon("Memo", variant) : getIcon(getLocationIcon(data?.location), variant),
            tooltipTitle: `${data?.memoClientName ? "Memo" : "Location"}`,
            access: true,
          },
          { label: data?.setDetails && data?.setDetails.length > 0 ? "setDetails" : null, Icon: getIcon("set", variant), tooltipTitle: "Sets", access: true },
          { label: data?.memoClientName?.length > 25 ? "EyeIcon" : null, Icon: getIcon("eye"), tooltipTitle: data?.memoClientName, access: true },
        ],
      },
    ],
    [data, variant]
  );

  useEffect(() => {
    setDetails(showDetails);
  }, []);


  return (
    <>
      <Box
        sx={{
          width: "26.25vw",
          height: "11.6vw",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0.5vw",
          backgroundColor: "#191818",
          color: "#fff",
          borderRadius: "0.5vw",
          border: ".05vw solid #C0C0C0"
        }}
      >
        <Box
          sx={{
            flex: 0.6,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            height: "100%",
          }}
        >
          {/* Left Content */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              justifyContent: "space-between"
            }}
          >
            {details[0]?.left?.map(
              (detail, index) =>
                detail.access && (
                  <Box
                    key={index}
                    display="flex"
                    alignItems="center"
                    sx={{ fontSize: ".6vw", cursor: "pointer"}}
                  >
                    <IconButton disableFocusRipple disableRipple sx={{ p: 0, m: 0, display: "flex", alignItems: "center", mt: index === 0 ? "-.15vw" : "" }} >
                      {detail.Icon}
                    </IconButton>
                    <CustomTooltip title={detail?.tooltipTitle} sx={{ marginTop: ".1vw" }}>
                      <Typography ml={1} whiteSpace="nowrap" sx={{
                        fontFamily: "Karla",
                        fontWeight: index === 0 ? 500 : 400,
                        fontSize: index === 0 ? ".9vw" : "0.8vw",
                        display: "flex",
                        alignItems: "center"
                      }}>
                        {detail?.label}
                      </Typography>
                    </CustomTooltip >
                  </Box>
                )
            )}
          </Box>
          <Box
            sx={{
              position: "relative",
              mr: "0.55vw"
            }}
          >
            {details[1]?.middle
              ?.map((detail, index) =>
                detail?.label ? (
                  <React.Fragment key={index}>
                    <CustomTooltip
                      title={detail?.tooltipTitle}
                      sx={{
                        marginTop: ".2vw",
                      }}
                    >
                      {detail?.access && (
                        <Box
                          className={detail?.label === "EyeIcon" ? `` : `content-new content-new-${index}`}
                          sx={{
                            fontSize: ".6vw",
                            ...(detail?.label === "EyeIcon" && {
                              position: "absolute",
                              bottom: 0,
                            }),
                          }}
                        >
                          {detail.click ? (
                            <IconButton disableRipple disableFocusRipple sx={{ p: 0 }} onClick={detail?.click}>
                              <Badge
                                badgeContent={detail?.badge > 1 ? detail?.badge : null}
                                sx={{
                                  "& .MuiBadge-badge": {
                                    backgroundColor: "white",
                                    color: "white",
                                  },
                                }}
                              >
                                {detail?.Icon}
                              </Badge>
                            </IconButton>
                          ) : (
                            detail?.Icon
                          )}
                        </Box>
                      )}
                    </CustomTooltip>
                  </React.Fragment>
                ) : null
              )}
          </Box>
        </Box>

        <Box
          sx={{
            position: "relative",
            flex: 0.4,
            width: "10.6vw",
            height: "10.6vw",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",

          }}
        >
          <img src={data?.transformedImageUrl} alt="Image" width={"100%"} height={"100%"} />
        </Box>
      </Box>
    </>
  );
};

export default React.memo(StockCard);
